import { render, staticRenderFns } from "./TagsEditor.vue?vue&type=template&id=5c0898db&scoped=true"
import script from "./TagsEditor.vue?vue&type=script&lang=js"
export * from "./TagsEditor.vue?vue&type=script&lang=js"
import style0 from "./TagsEditor.vue?vue&type=style&index=0&id=5c0898db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0898db",
  null
  
)

export default component.exports